export const SESSION_ENDED_EVENT = "gshard:session-ended";
export const SESSION_IDLE_MESSAGE = "Сеанс завершён после 12 часов бездействия. Войдите снова.";

let idleExpired = false;
let generation = 0;

export function sessionIdleExpired() { return idleExpired; }
export function sessionGeneration() { return generation; }

/** Called only after a new explicit authentication has succeeded. */
export function clearSessionEnded() { idleExpired = false; generation++; }

export function announceIdleExpiry(expectedGeneration = generation) {
  if (expectedGeneration !== generation || idleExpired) return;
  idleExpired = true;
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SESSION_ENDED_EVENT, {
      detail: { code: "SESSION_IDLE_EXPIRED", message: SESSION_IDLE_MESSAGE },
    }));
  }
}
